import { AppDispatch } from '@/app/store';
import { Outlet } from 'react-router-dom';
import { clearLetterDraftId } from '@/services/createFormSlice';
import { useAppDispatch } from '@/app/hooks';
import React, { FC, ReactElement, useEffect } from 'react';

export const AnswerBlock: FC = (): ReactElement => {
  const dispatch: AppDispatch = useAppDispatch();

  useEffect(() => {
    return (): void => {
      dispatch(clearLetterDraftId());
    };
  }, [dispatch]);

  return <Outlet />;
};
